// Imports
import React from 'react';
import Feature from '..';
import feature from './feature';


// Function component
const CommunityInfo: React.FC = () => <Feature {...feature} />;

export default CommunityInfo;
